import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { StyleSheet, css } from 'aphrodite';
import { Layout, Flexbox, Font, ColorEnvironment } from './Styles';
import LogoEn from './images/logo_en.png';
import LogoFr from './images/logo_fr.png';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  container: {
    height: '80%'
  },
  column: {
    marginLeft: 20,
    marginRight: 20
  },
  logoEn: {
    marginTop: 40,
    '@media (max-width: 760px)': {
      height: 290,
      width: 290
    },
    '@media (min-width: 760px)': {
      height: 325,
      width: 325
    },
    backgroundSize: '100% 100%',
    backgroundImage: `url(${LogoEn})`
  },
  logoFr: {
    marginTop: 40,
    '@media (max-width: 760px)': {
      height: 290,
      width: 290
    },
    '@media (min-width: 760px)': {
      height: 325,
      width: 325
    },
    backgroundSize: '100% 100%',
    backgroundImage: `url(${LogoFr})`
  },
  languageButton: {
    width: 80,
    marginTop: 30,
    marginLeft: 10,
    marginRight: 10,
    padding: 15,
    borderRadius: 10,
    textAlign: 'center'
  },
  link: {
    textDecoration: 'none',
    cursor: 'pointer',
  }
});

class Splash extends Component {
  render() {
    return(
      <div className={css(Layout.fullScrollingContentArea)}>
        <div className={css(Layout.contentArea, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, styles.container)}>
          <div className={css(Flexbox.row, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.wrap)}>
            <div className={css(styles.column)}>
              <Link to="/about" className={css(styles.link)} onClick={this.setLocale.bind(this, 'en')}>
                <div className={css(styles.logoEn)}/>
                <div className={css(Flexbox.row, Flexbox.axisCenter, Flexbox.crossCenter)}>
                  <div className={css(styles.languageButton, Font.heading, ColorEnvironment.secondaryInverse)}>Play!</div>
                </div>
              </Link>
            </div>
            <div className={css(styles.column)}>
              <Link to="/about" className={css(styles.link)} onClick={this.setLocale.bind(this, 'fr')}>
                <div className={css(styles.logoFr)}/>
                <div className={css(Flexbox.row, Flexbox.axisCenter, Flexbox.crossCenter)}>
                  <div className={css(styles.languageButton, Font.heading, ColorEnvironment.secondaryInverse)}>Jouez!</div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  setLocale(locale) {
    Locale.setLocale(locale);
  }
}

export default Splash;



// WEBPACK FOOTER //
// ./src/Splash.js